<button class="menu" mat-raised-button class="d-md-none menu text-center" (click)="openMenuClick()">
  <img src="assets/images/ic-menu.svg" alt="" />
</button>
<nav [ngClass]="openMenu ? 'open' : ''">
  <div class="container">
    <div class="d-lg-flex align-items-center justify-content-md-between py-2">
      <div class="logo pointer" routerLink="/crowdfunding">
        <img class="d-lg-block d-none" height="40" src="assets/images/logo.png"
          [title]="'MENU.TOOLBAR.TITLE' | translate" [alt]="'MENU.TOOLBAR.ALT' | translate">
        <img class="d-lg-none d-inline-block" src="assets/images/min-logo.png"
          [title]="'MENU.TOOLBAR.TITLE' | translate" [alt]="'MENU.TOOLBAR.ALT' | translate">
      </div>
      <div class="close-menu pointer d-md-none " (click)="closesMenu()"><i class="bi bi-x-lg "></i></div>
      <hr class="d-md-none">
      <div class="menu d-flex flex-column flex-md-row align-items-md-center">
        <div class="d-flex flex-column flex-md-row order-md-1 order-2">

          <div class="pointer mt-lg-0 mt-3" (click)="scrollTo('home');closesMenu()" routerLinkActive="active">{{'MENU.TOOLBAR.HOME' |
            translate}}</div>
          <div class="ms-lg-3 py-lg-0 py-2 pointer" (click)="scrollTo('soluciones');closesMenu()" routerLinkActive="active">
            {{'MENU.TOOLBAR.SOLUTION' | translate}}
          </div>
          <div class="ms-lg-3 py-lg-0 py-2 pointer" (click)="scrollTo('objetivo');closesMenu()" routerLinkActive="active">
            {{'MENU.TOOLBAR.OBJETIVE' | translate}}
          </div>
          <div class="ms-lg-3 py-lg-0 py-2 pointer" (click)="navigateToProjects();closesMenu()" routerLinkActive="active">
            {{'MENU.TOOLBAR.PROJECTS' | translate}}
          </div>
          <div class="ms-lg-3 py-lg-0 py-2 pointer" (click)="scrollTo('contacto');closesMenu()" routerLinkActive="active">
            {{'MENU.TOOLBAR.CONTACT' | translate}}</div>

        </div>
        <div class="d-flex order-md-2 order-1">
        <div class="ms-lg-3" *ngIf="token == ''; else loggedUser">
          <button class="primary" routerLink="/auth/login">{{'MENU.TOOLBAR.SIGN_UP' | translate}}</button>
          <button class="outline ms-3" routerLink="/auth/register">{{'MENU.TOOLBAR.REGISTER' | translate}}</button>
        </div>
        <ng-template #loggedUser>
          <div class="notification ms-lg-3 d-md-block d-none">

            <i class="bi bi-bell pointer" [matMenuTriggerFor]="notificationsMenu"></i>
            <ng-container *ngIf="badgeActive">
              <span class="badge"></span>
            </ng-container>
            <mat-menu class="notification" #notificationsMenu="matMenu" overlapTrigger="false" xPosition="before">
              <ng-container *ngIf="notifications">
                <ng-container *ngIf="notifications.list.length > 0; else noNotifications">
                  <div class="viewedAll px-3 pointer" (click)="setViewedAll()">Marcar como Leidas</div>
                  <button class="border-top" mat-menu-item (click)="goToUrl(n)" class="{{n.viewed ? 'viewed' : ''}}"
                    *ngFor="let n of notifications.list">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="text">
                        <div class="title">{{n.title}}</div>
                        <div class="body">{{n.body}}</div>
                      </div>
                      <span class="badge-viewed {{n.viewed ? 'viewed' : ''}} me-2" matTooltipPosition="above"
                        [matTooltip]="!n.viewed ? 'Marcar como leido' : 'Marcar como no leido'"></span>
                    </div>

                  </button>
                </ng-container>
                <ng-template #noNotifications>
                  <p class="text-center">No tiene notificaciones</p>
                </ng-template>
              </ng-container>
            </mat-menu>
          </div>
          <div class="d-flex align-items-center pointer ms-lg-3" [matMenuTriggerFor]="menu">
            <div class="avatar">{{setAvatarLetters()}}</div>
            <span class="username mx-3">{{getUsername()}}</span>
            <span class="material-icons"> expand_more </span>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item routerLink="/platform/dashboard" (click)="closesMenu()">{{'PLATFORM.MENU.DASHBOARD' | translate}}</button>
            <button mat-menu-item routerLink="/platform/profile/personal-information" (click)="closesMenu()">{{'PLATFORM.MENU.PROFILE' |
              translate}}</button>
            <button mat-menu-item routerLink="/platform/portfolio" (click)="closesMenu()">{{'PLATFORM.MENU.PORTFOLIO' | translate}}</button>
            <button mat-menu-item (click)="logout();closesMenu()">{{'PLATFORM.MENU.LOGOUT' | translate}}</button>
          </mat-menu>

        </ng-template></div>
      </div>
    </div>
  </div>
</nav>